import { render } from "./LoginPerson.vue?vue&type=template&id=61ab9f00"
import script from "./LoginPerson.vue?vue&type=script&lang=js"
export * from "./LoginPerson.vue?vue&type=script&lang=js"

import "./LoginPerson.vue?vue&type=style&index=0&id=61ab9f00&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__